import { Box, type SxProps, type Theme } from "@mui/material";
import React from "react";

import { SectionHeader } from "@/components/common/SectionHeader";

type ComparisonBreakdownPanelProps = {
  title: React.ReactNode;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  exportAction?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  className?: string;
};

const basePanelSx: SxProps<Theme> = {
  overflow: "auto",
  bgcolor: "white",
  borderRadius: "24px",
  p: { xs: 2, md: 3 },
  minWidth: 0,
  boxShadow: "0 4px 14px rgba(147, 197, 253, 0.45)",
};

export function ComparisonBreakdownPanel({
  title,
  meta,
  actions,
  exportAction,
  footer,
  children,
  sx,
  className,
}: ComparisonBreakdownPanelProps) {
  return (
    <Box className={className} sx={[basePanelSx, ...(Array.isArray(sx) ? sx : [sx])]}>
      <SectionHeader title={title} leading={meta} actions={actions} trailing={exportAction} />
      {children}
      {footer}
    </Box>
  );
}
